import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowUpRightFromSquare, 
  faChevronLeft, 
  faChevronRight 
} from '@fortawesome/free-solid-svg-icons';
import './Portfolio.css';

const Portfolio = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const projects = [
    { 
      name: "Kawasaki Miramontes", 
      url: "https://kawasaki-miramontes.web.app/", 
      domain: "kawasaki-miramontes.web.app",
      tag: "Software Empresarial"
    },
    { 
      name: "Grupo Diana", 
      url: "https://grupodiana.com.mx/", 
      domain: "grupodiana.com.mx",
      tag: "Plataforma Web & Catálogo"
    },
    { 
      name: "SIMAP", 
      url: "https://simap.com.mx", 
      domain: "simap.com.mx",
      tag: "Plataforma Web"
    },
    { 
      name: "Cir Junior", 
      url: "https://cirjunior.com", 
      domain: "cirjunior.com",
      tag: "Plataforma Web"
    }
  ];

  const getScreenshotUrl = (url) =>
    `https://api.microlink.io/?url=${encodeURIComponent(url)}&screenshot=true&meta=false&embed=screenshot.url`;

  const paginate = (newDirection) => {
    setDirection(newDirection);
    setCurrentIndex((prev) => {
      let nextIndex = prev + newDirection;
      if (nextIndex < 0) return projects.length - 1;
      if (nextIndex >= projects.length) return 0;
      return nextIndex;
    });
  };

  const currentProject = projects[currentIndex];

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 120 : -120,
      opacity: 0,
      scale: 0.96
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] }
    },
    exit: (dir) => ({
      x: dir > 0 ? -120 : 120,
      opacity: 0,
      scale: 0.96,
      transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] }
    })
  };

  return (
    <section id="portafolio" className="portfolio-section">
      <div className="portfolio-glow-bg"></div>

      <div className="portfolio-container">
        <div className="portfolio-header">
          <span className="portfolio-badge">Casos de Éxito & Portafolio</span>
          <h2 className="portfolio-title">Proyectos que Hablan por Nosotros</h2>
          <p className="portfolio-subtitle">
            Ingeniería aplicada a productos reales con alta disponibilidad y desempeño.
          </p>
        </div>

        {/* Contenedor del Carrusel Horizontal */}
        <div className="horizontal-carousel-wrapper">
          {/* Botón Flecha Izquierda */}
          <button 
            className="carousel-arrow-btn prev" 
            onClick={() => paginate(-1)}
            aria-label="Proyecto anterior"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          {/* Escenario de la Tarjeta */}
          <div className="carousel-stage-horizontal">
            <AnimatePresence initial={false} custom={direction} mode="wait">
              <motion.div
                key={currentIndex}
                custom={direction}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                className="portfolio-card horizontal-card"
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0.2}
                onDragEnd={(e, { offset, velocity }) => {
                  const swipe = offset.x;
                  if (swipe < -50 || velocity.x < -300) {
                    paginate(1);
                  } else if (swipe > 50 || velocity.x > 300) {
                    paginate(-1);
                  }
                }}
              >
                <a 
                  href={currentProject.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="portfolio-link-wrapper"
                >
                  <div className="browser-bar">
                    <div className="browser-dots">
                      <span className="dot dot-red" />
                      <span className="dot dot-yellow" />
                      <span className="dot dot-green" />
                    </div>
                    <div className="browser-domain">{currentProject.domain}</div>
                    <div className="browser-spacer" />
                  </div>

                  <div className="preview-container">
                    <img
                      src={getScreenshotUrl(currentProject.url)}
                      alt={currentProject.name}
                      className="preview-image"
                      loading="lazy"
                    />
                    <div className="preview-overlay">
                      <span className="view-btn">
                        Ver Proyecto <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                      </span>
                    </div>
                  </div>
                </a>

                <div className="card-info">
                  <div className="card-info-header">
                    <span className="project-tag">{currentProject.tag}</span>
                    <span className="project-counter">
                      {String(currentIndex + 1).padStart(2, '0')} / {String(projects.length).padStart(2, '0')}
                    </span>
                  </div>
                  <h4 className="project-name">{currentProject.name}</h4>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Botón Flecha Derecha */}
          <button 
            className="carousel-arrow-btn next" 
            onClick={() => paginate(1)}
            aria-label="Siguiente proyecto"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        {/* Indicadores / Dots Inferiores */}
        <div className="carousel-indicators-horizontal">
          {projects.map((_, i) => (
            <button
              key={i}
              className={`carousel-dot-h ${i === currentIndex ? 'active' : ''}`}
              onClick={() => {
                setDirection(i > currentIndex ? 1 : -1);
                setCurrentIndex(i);
              }}
              aria-label={`Ir al proyecto ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;